<template>
    <div class="page bg-fff">
        <backTitleBar></backTitleBar>
        <div class="pd-25 fs-28">
            <div>抱歉~，扫描结果不匹配，请核对二维码</div>
            <div class="mt-10">{{content}}</div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "scanBlank",
        components:{backTitleBar},
        data(){
            return{
                content:null
            }
        },
        created() {
            this.content = this.$route.query.content;
        },
        methods:{

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// scanBlank.vue?0e78fbeb